var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input-dialog',{attrs:{"shown":_vm.innerShown,"title":_vm.title || _vm.$t('dialog.newDirectory.title'),"prompt":_vm.prompt || _vm.$t('dialog.newDirectory.prompt')},on:{"update:shown":function($event){_vm.innerShown=$event},"confirmed":_vm.createDirectory}})
}
var staticRenderFns = []

export { render, staticRenderFns }